import request from '@/utils/request'

let PageApi = {

    /*获取数据*/
    detail(data) {
        return request._post('/shop/page.page/detail', data);
    },
    /*上架样式*/
    toAddPage(data) {
        return request._get('/shop/page.page/add', data);
    },
    /*上架样式*/
    addPage(data) {
        return request._post('/shop/page.page/add', data);
    },
    /*页面列表*/
    PageList(data) {
        return request._post('/shop/page.page/index', data);
    },
    /*删除页面*/
    deletePage(data) {
        return request._post('/shop/page.page/delete', data);
    },
    /*设为首页*/
    setHome(data) {
        return request._post('/shop/page.page/setHome', data);
    },
    /*编辑页面*/
    editHome(data) {
        return request._get('/shop/page.page/home', data);
    },
    /*编辑页面*/
    editPage(data) {
        return request._get('/shop/page.page/edit', data);
    },
    /*保存编辑页面*/
    SavePage(data) {
        return request._post('/shop/page.page/edit', data);
    },
    /*获取分类*/
    getCategory(data) {
        return request._get('/shop/page.page/category', data);
    },

    /*提交分类*/
    postCategory(data) {
        return request._post('/shop/page.page/category', data);
    },
    /*编辑用户中心页面*/
    editUser(data) {
        return request._get('/shop/page.page/user', data);
    },
    /* 保存用户中心页面 */
    saveUser(data) {
        return request._post('/shop/page.page/user', data);
    },
    /*编辑政商企中心页面*/
    editSupply(data) {
        return request._get('/shop/page.page/supply', data);
    },
    /* 保存政商企中心页面 */
    saveSupply(data) {
        return request._post('/shop/page.page/supply', data);
    },
    /* 编辑底部菜单 */
    editTabbar(data) {
        return request._get('/shop/page.page/tabbar', data);
    },
     /* 保存底部菜单 */
     saveTabbar(data) {
        return request._post('/shop/page.page/tabbar', data);
    },
    editWebSite(data) {
        return request._get('/shop/page.page/website', data);
    },
    saveWebSite(data) {
        return request._post('/shop/page.page/website', data);
    },

    // 全局风格
    getGlobalStyleList(data) {
      return request._get('/shop/page.globalStyle/index', data);
    },
    /*上架样式*/
    saveStyle(data) {
      return request._post('/shop/page.globalStyle/save', data);
    },
    /*设为首页*/
    setDefault(data) {
      return request._post('/shop/page.globalStyle/setDefault', data);
    },
    /*删除风格*/
    deleteStyle(data) {
      return request._post('/shop/page.globalStyle/delete', data);
    },
    /*编辑页面*/
    editStyle(data) {
      return request._get('/shop/page.globalStyle/edit', data);
    },
    /*更新样式*/
    updateStyle(data) {
      return request._post('/shop/page.globalStyle/update', data);
    },
    /*系统首页列表*/
    getIndexList(data) {
      return request._get('/shop/page.page/getIndexList', data);
    },
    /*设置首页模板默认*/
    setPageDefault(data){
      return request._post('/shop/page.page/editIndex', data);
    },
    /*添加首页模板*/
    addIndex(data){
      return request._post('/shop/page.page/addIndex', data);
    },
    /*编辑首页模板*/
    editIndexPage(data){
      return request._get('/shop/page.page/editIndexPage', data);
    },
    /*添加会员中心模板*/
    saveUserPage(data){
      return request._post('/shop/page.page/saveUserPage', data);
    },
  /*添加分销中心模板*/
  saveAgentPage(data){
    return request._post('/shop/page.page/saveAgentPage', data);
  },
    /*获取手机角色*/
    getMobileRole(data){
      return request._post('/shop/page.page/getMobileRole', data);
    },


}

export default PageApi;



// WEBPACK FOOTER //
// ./src/api/page.js